import { render, staticRenderFns } from "./infoBtn.vue?vue&type=template&id=88e091dc&scoped=true&"
import script from "./infoBtn.vue?vue&type=script&lang=js&"
export * from "./infoBtn.vue?vue&type=script&lang=js&"
import style0 from "./infoBtn.vue?vue&type=style&index=0&id=88e091dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e091dc",
  null
  
)

export default component.exports